import { Box, Typography, Link, Grid, Divider } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

interface FooterLink {
  label: string;
  to?: string;
  href?: string;
}

const COLUMNS: Array<{ title: string; links: FooterLink[] }> = [
  {
    title: "Product",
    links: [
      { label: "Features", to: "/features" },
      { label: "Pricing", to: "/pricing" },
      { label: "Docs", to: "/docs" },
    ],
  },
  {
    title: "Resources",
    links: [
      { label: "Blog", to: "/blog" },
      { label: "API Status", to: "/status" },
      { label: "Changelog", to: "/blog" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About", to: "/about" },
      { label: "Contact", href: "mailto:sales@pdfglyph.com" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Terms of Service", to: "/terms" },
      { label: "Privacy Policy", to: "/privacy" },
    ],
  },
];

export default function MarketingFooter() {
  return (
    <Box
      component="footer"
      sx={{ borderTop: 1, borderColor: "divider", py: 4, px: { xs: 2, md: 4 } }}
    >
      <Grid container spacing={4} sx={{ mb: 3 }}>
        {COLUMNS.map((col) => (
          <Grid item xs={6} md={3} key={col.title}>
            <Typography variant="subtitle2" fontWeight={700} gutterBottom>
              {col.title}
            </Typography>
            {col.links.map((link) =>
              link.to ? (
                <Link
                  key={link.label}
                  component={RouterLink}
                  to={link.to}
                  display="block"
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    textDecoration: "none",
                    mb: 0.5,
                    "&:hover": { color: "text.primary" },
                  }}
                >
                  {link.label}
                </Link>
              ) : (
                <Link
                  key={link.label}
                  href={link.href}
                  display="block"
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    textDecoration: "none",
                    mb: 0.5,
                    "&:hover": { color: "text.primary" },
                  }}
                >
                  {link.label}
                </Link>
              ),
            )}
          </Grid>
        ))}
      </Grid>
      <Divider sx={{ mb: 2 }} />
      <Typography variant="caption" color="text.secondary">
        &copy; {new Date().getFullYear()} PDFGlyph. All rights reserved.
      </Typography>
    </Box>
  );
}
